import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  fill: "none",
  viewBox: "0 0 16 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#FDBC04",
        d: "M14.985 6.176q.001.01-.005.02l-1.417 6.491a1 1 0 0 1-.983.813H3.42a1 1 0 0 1-.982-.813L1.02 6.196l-.004-.02a1 1 0 0 1 1.734-.84l2.105 2.269 2.237-5.018V2.58a1 1 0 0 1 1.816 0v.006l2.238 5.018 2.104-2.268a1 1 0 0 1 1.732.839z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 .5h16v16H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }